export const TimeBaseScore = Object.freeze({
  QUEUE: 'queue',
  SYSTEM: 'system',
});
